import React from "react";

export const Hero = () => {
  return (
    <>
      <section class="hero">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 hero-leftWhyVTV">
              {/* <div class="herofirst">
                <h2 class="WindText">
                  providing top tier engineering services
                </h2>
                <p class="text-white px-6">
                  VTV Energy offers the latest renewable energy technologies,
                  from solar energy, wind energy to green <br />
                  hydrogen energy through our global partnerships.
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
